import React from 'react';
import Sidebar from './Sidebar';

const DashboardLayout = ({ children }) => {
  return (
    <div className="flex h-screen bg-light overflow-hidden">
      {/* الشريط الجانبي الثابت */}
      <Sidebar />
      
      {/* المحتوى الرئيسي */}
      <div className="flex-1 overflow-auto scrollbar-hidden">
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout; 
